import { render, staticRenderFns } from "./AccountAssignmentGroup.vue?vue&type=template&id=a88ac4f0"
import script from "./AccountAssignmentGroup.vue?vue&type=script&lang=js"
export * from "./AccountAssignmentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports